const styles = (theme) => ({
    tabsContainer: {
        marginTop: '10px',
        marginBottom: '10px',
        borderBottom: '1px solid #ccc',
    },
    tabs: {
        flex: 1,
        textTransform: 'none',
    },
    tab: { maxWidth: '220px' },
    containerForm: {
        position: 'relative',
        paddingBottom: '130px',
    },
    containerMainData: {
        marginTop: '30px',
    },
    actionsContainer: {
        flex: 1,
        padding: '30px',
        margin: '50px 12px 0 12px',
        display: 'flex',
        backgroundColor: 'rgba(0, 0, 0, 0.05)',
    },
    actionsBtns: {
        borderRadius: '20px',
        width: '190px',
        height: '40px',
    },
    finalizeContainer: {
        position: 'absolute',
        right: '-1.13em',
        width: 'calc(100% + 4em)',
        bottom: '-1.2em',
        backgroundColor: '#e9e9e9',
        justifyContent: 'flex-end',
        padding: '20px',
    },
    finalizeBtn: {
        borderRadius: '25px',
        paddingRight: '20px',
        paddingLeft: '20px',
        height: '50px',
    },
    colorWhite: {
        color: '#fff',
    },
    loading: {
        margin: '0',
    },
    centerProgress: {
        textAlign: 'center',
    },
    titleTable: {
        fontWeight: '500',
    },
    table: {
        margin: '0 0 30px 0',
        backgroundColor: '#fff',
    },
    tableError: {
        borderCollapse: 'initial',
        margin: '0 0 30px 0',
        border: '2px solid #b71c1c',
        backgroundColor: '#fff',
    },
    tableRow: {
        verticalAlign: 'middle',
    },
    headTableCell: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
    },
    yellowTitle: {
        fontWeight: '500',
        marginBottom: '10px',
        color: '#FEAD3D',
        fontSize: '1rem',
    },
    greenTitle: {
        fontWeight: '500',
        marginBottom: '10px',
        color: '#51Ac3B',
        fontSize: '1rem',
    },
    scheduleBoard: {
        maxHeight: '400px',
    },
    popContent: {
        width: 340,
        backgroundColor: theme.palette.background.paper,
    },
});

export default styles;
